import type { FC } from "react"

import styles from "./BulkToggleRow.module.scss"

import FlagCheckbox from "../FlagCheckbox"
import type { FlagEditState } from "../useFeatureFlagTab"
import {
	type FragmentType,
	getFragmentData,
} from "@/souhl_admin/gql/__generated__"
import { graphql } from "@/souhl_admin/gql/__generated__/gql"

const BulkToggleRowCompanyFeatureFlagFragment = graphql(/* GraphQL */ `
	fragment BulkToggleRowCompanyFeatureFlag on CompanyFeatureFlag {
		featureFlag {
			id
		}
	}
`)

const BulkToggleRowSalonFragment = graphql(/* GraphQL */ `
	fragment BulkToggleRowSalon on Salon {
		id
	}
`)

type Props = {
	companyFeatureFlags: FragmentType<
		typeof BulkToggleRowCompanyFeatureFlagFragment
	>[]
	salons: FragmentType<typeof BulkToggleRowSalonFragment>[]
	flagStates: Record<string, FlagEditState>
	onBulkToggle: (flagId: string) => void
}

const BulkToggleRow: FC<Props> = ({
	companyFeatureFlags,
	salons,
	flagStates,
	onBulkToggle,
}) => {
	const cfs = companyFeatureFlags.map((cf) =>
		getFragmentData(BulkToggleRowCompanyFeatureFlagFragment, cf)
	)
	const salonsData = salons.map((s) =>
		getFragmentData(BulkToggleRowSalonFragment, s)
	)

	return (
		<tr className={styles.bulkRow}>
			<td className={styles.labelTd}>
				<span className={styles.bulkLabel}>一括操作</span>
			</td>
			{cfs.map((cf) => {
				const state = flagStates[cf.featureFlag.id]
				if (state?.companyWide) {
					return (
						<td key={cf.featureFlag.id} className={styles.flagTd}>
							<span className={styles.dash}>—</span>
						</td>
					)
				}
				const allChecked =
					salonsData.length > 0 &&
					salonsData.every((s) => state?.enabledSalonIds.includes(s.id))
				const someChecked = salonsData.some((s) =>
					state?.enabledSalonIds.includes(s.id)
				)
				return (
					<td key={cf.featureFlag.id} className={styles.flagTd}>
						<FlagCheckbox
							checked={allChecked}
							indeterminate={someChecked && !allChecked}
							onChange={() => onBulkToggle(cf.featureFlag.id)}
							size="small"
						/>
					</td>
				)
			})}
		</tr>
	)
}

export default BulkToggleRow
